"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.irHeader = exports.logoHeader = exports.approvals = exports.approvalCell = exports.irItemDataToGridRow = exports.IRGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var officesList_1 = require("common/global/officesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var useBudgetLinesOptions_1 = __importDefault(require("common/hooks/useBudgetLinesOptions"));
var useCurrenciesOptions_1 = __importDefault(require("common/hooks/useCurrenciesOptions"));
var useOfficesOptions_1 = __importDefault(require("common/hooks/useOfficesOptions"));
var lodash_1 = require("lodash");
var map_1 = __importDefault(require("lodash/map"));
var Grid_1 = require("portal/components/Grid/Grid");
var actionCell_1 = require("portal/components/Grid/helpers/actionCell");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var titleCell_1 = require("portal/components/Grid/helpers/titleCell");
var valueByMode_1 = require("portal/components/Grid/helpers/valueByMode");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var header_1 = require("portal/components/header");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var donorsList_1 = require("common/global/donorsList");
require("./IRstyle.css");
var moment_1 = __importDefault(require("moment"));
var useProjectsOptions_1 = __importDefault(require("common/hooks/useProjectsOptions"));
var permissiontypes_1 = require("portal/pages/Tables/Users/permissiontypes");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var whiteColor = "#fff";
var IRGrid = function (_a) {
    var _b, _c;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch, irId = _a.irId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var officesOptions = (0, useOfficesOptions_1.default)();
    var projectsOptions = (0, useProjectsOptions_1.default)();
    var currenciesOptions = (0, useCurrenciesOptions_1.default)();
    var budgetLinesOptions = (0, useBudgetLinesOptions_1.default)(state);
    var itemsHeader = function (mode) { return __spreadArray([
        (0, titleCell_1.TitleCell)({ title: t("ir.no") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.itemDescriptionSpecifications"), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("ir.unit") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.quantity") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.location") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.estimatedUnitPrice") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.estimatedTotalPrice") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.reqruiedDeliveryDate") }),
        (0, titleCell_1.TitleCell)({ title: t("ir.budgetLine") }),
        (0, titleCell_1.TitleCell)({ title: "Percentages" })
    ], (mode === "view"
        ? []
        : [(0, actionCell_1.actionCell)({ action: "addRow", payload: "irItems" })]), true); };
    var hasSignature = false;
    var getCellsForIrItem = (0, exports.irItemDataToGridRow)(state, mode, officesOptions, projectsOptions, budgetLinesOptions, t);
    var items = (0, map_1.default)(state.irItems, getCellsForIrItem);
    var donorId = (_b = projectsList_1.globalProjectsData[state.projectId]) === null || _b === void 0 ? void 0 : _b.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_c = donorsList_1.globalDonorsData[donorId]) === null || _c === void 0 ? void 0 : _c.logo, height: 100, width: 500, colSpan: 4, textAlign: "center" });
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            logoHeader({
                projectId: state.projectId,
                idaLogo: miLogo,
                title: t("ir.internalRequestIr"),
                colSpan: 2,
                addEmptyCell: mode === "edit",
            })
        ], irHeader(state, mode, officesOptions, projectsOptions, budgetLinesOptions, t), true), [
            itemsHeader(mode)
        ], false), items, true), itemsFooter(state, mode, currenciesOptions), true), approvals(state, t, mode), true),
    };
    function itemsFooter(state, mode, currenciesOptions) {
        var _a, _b, _c, _d, _e;
        var totalEstimatedCostInUsdMap = state.irItems.map(function (e) {
            var exRate = state.exchangeRate == 0 ? 1 : state.exchangeRate;
            return (e.quantity * e.estimatedPrice) / exRate;
        });
        var totalEstimatedCostInLocalCurrencyMap = state.irItems.map(function (e) {
            return e.estimatedPrice * e.quantity;
        });
        var totalEstimatedCostInUsd = (0, lodash_1.sumBy)(totalEstimatedCostInUsdMap);
        var totalEstimatedCostInLocalCurrency = (0, lodash_1.sumBy)(totalEstimatedCostInLocalCurrencyMap);
        var projectCurrencyId = (_a = projectsList_1.globalProjectsData[state.projectId]) === null || _a === void 0 ? void 0 : _a.currencyId;
        return [
            [
                (0, emptyCell_1.emptyCell)({ colSpan: 4, rowSpan: 2 }),
                (0, titleCell_1.TitleCell)({
                    title: t("ir.totalEstimatedCostLocalCurrency"),
                    colSpan: 3,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: state === null || state === void 0 ? void 0 : state.currencyId,
                    viewValue: (_b = currenciesList_1.globalCurrenciesData[state === null || state === void 0 ? void 0 : state.currencyId]) === null || _b === void 0 ? void 0 : _b.name,
                    inputType: "select",
                    selectData: currenciesOptions,
                    path: "currencyId",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: "view",
                    value: totalEstimatedCostInLocalCurrency,
                    path: "totalEstimatedCostInLocalCurrency",
                }),
                (0, emptyCell_1.emptyCell)({ rowSpan: 2, colSpan: mode === "edit" ? 2 : 1 }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t("ir.totalEstimatedCostInUsd"), colSpan: 3 }),
                (0, valueByMode_1.ValueByMode)({ mode: "view", value: "USD" }),
                (0, valueByMode_1.ValueByMode)({
                    mode: "view",
                    value: totalEstimatedCostInUsd === null || totalEstimatedCostInUsd === void 0 ? void 0 : totalEstimatedCostInUsd.toFixed(2),
                    path: "totalEstimatedCostInUsd",
                }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t("ir.requestedBy") }),
                (0, titleCell_1.TitleCell)({
                    title: "".concat((_c = usersList_1.globalUsersData[state.requestedBy]) === null || _c === void 0 ? void 0 : _c.name),
                    colSpan: 1,
                    backgroundColor: whiteColor,
                }),
                (0, titleCell_1.TitleCell)({ title: t("ir.title") }),
                (0, titleCell_1.TitleCell)({
                    title: "".concat((_d = usersList_1.globalUsersData[state.requestedBy]) === null || _d === void 0 ? void 0 : _d.jobTitle),
                    colSpan: 1,
                    backgroundColor: whiteColor,
                }),
                (0, titleCell_1.TitleCell)({ title: t("ir.date") }),
                (0, titleCell_1.TitleCell)({
                    title: mode === "view"
                        ? t("common.date", {
                            date: (0, getDateForCell_1.default)(state.requestedAt, mode),
                        })
                        : null,
                    colSpan: 1,
                    backgroundColor: whiteColor,
                }),
                (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && ((_e = usersList_1.globalUsersData[state.requestedBy]) === null || _e === void 0 ? void 0 : _e.signatureURL),
                    colSpan: 3,
                }),
                // TitleCell({ title: ``, colSpan: 1, backgroundColor: whiteColor }),
            ],
        ];
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: state, dispatch: dispatch, type: "IR", orderRef: collectionsRef_1.IRsRef.doc(irId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: "#fff" } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                            payload: undefined,
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
};
exports.IRGrid = IRGrid;
var irItemDataToGridRow = function (state, mode, officesOptions, projectsOptions, budgetLinesOptions, t) { return function (irItem, index) {
    var _a, _b, _c, _d, _e;
    var estimatedTotalPrice = irItem.quantity * irItem.estimatedPrice;
    var product = state.irItems[index].product;
    var unit = product ? unitsList_1.globalUnitsData[product.unitId].name : "";
    return __spreadArray([
        (0, titleCell_1.TitleCell)({ title: index + 1 + "", backgroundColor: whiteColor }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: (_a = product === null || product === void 0 ? void 0 : product.name) !== null && _a !== void 0 ? _a : "",
            viewValue: product === null || product === void 0 ? void 0 : product.name,
            inputType: "productSelect",
            path: "irItems[".concat(index, "].product"),
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
            colSpan: 1,
        }),
        (0, titleCell_1.TitleCell)({
            title: (_b = product === null || product === void 0 ? void 0 : product.description) !== null && _b !== void 0 ? _b : "",
            backgroundColor: whiteColor,
        }),
        (0, titleCell_1.TitleCell)({ title: unit !== null && unit !== void 0 ? unit : "", colSpan: 1, backgroundColor: whiteColor }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: (_c = irItem.quantity) !== null && _c !== void 0 ? _c : "",
            inputType: "numberInput",
            path: "irItems[".concat(index, "].quantity"),
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: irItem === null || irItem === void 0 ? void 0 : irItem.officeId,
            viewValue: (_d = officesList_1.globalOfficesData[irItem === null || irItem === void 0 ? void 0 : irItem.officeId]) === null || _d === void 0 ? void 0 : _d.name,
            inputType: "select",
            path: "irItems[".concat(index, "].officeId"),
            selectData: officesOptions,
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: (_e = irItem.estimatedPrice) !== null && _e !== void 0 ? _e : "",
            inputType: "numberInput",
            path: "irItems[".concat(index, "].estimatedPrice"),
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        }),
        (0, titleCell_1.TitleCell)({
            title: estimatedTotalPrice === null || estimatedTotalPrice === void 0 ? void 0 : estimatedTotalPrice.toFixed(2),
            backgroundColor: whiteColor,
        }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: mode === "view"
                ? t("common.date", {
                    date: (0, getDateForCell_1.default)(irItem.requiredDeliveryDate, mode),
                })
                : (0, getDateForCell_1.default)(irItem.requiredDeliveryDate, mode),
            inputType: "datePicker",
            path: "irItems[".concat(index, "].requiredDeliveryDate"),
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: irItem.budgetLinesIds,
            viewValue: irItem.budgetLinesIds
                .map(function (budgetLineId) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[budgetLineId]) === null || _a === void 0 ? void 0 : _a.code; })
                .join(", "),
            colSpan: 1,
            selectMode: "multiple",
            inputType: "select",
            path: "irItems[".concat(index, "].budgetLinesIds"),
            selectData: budgetLinesOptions,
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        }),
        (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: irItem.budgetLinesPercentages,
            viewValue: irItem.budgetLinesPercentages.join(", "),
            colSpan: 1,
            selectMode: "tags",
            inputType: "select",
            path: "irItems[".concat(index, "].budgetLinesPercentages"),
            selectData: [],
            required: state.triedSubmitting,
            triedSubmitting: state.triedSubmitting,
        })
    ], (mode === "view"
        ? []
        : [(0, actionCell_1.actionCell)({ action: "delete", payload: index })]), true);
}; };
exports.irItemDataToGridRow = irItemDataToGridRow;
var approvalCell = function (state, approvalType, t, requiredApprovalType) {
    var _a, _b;
    var projectId = state.projectId;
    var totalEstimatedCostInLocalCurrency = state.totalEstimatedCostInLocalCurrency;
    // const approvalPermissions = hasProjectPermissionWithMinAndMax(
    //   projectId,
    //   [`IR${approvalType}Approval`],
    //   totalEstimatedCostInLocalCurrency
    // );
    var approvalPermissions = true;
    var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
        return e.approvalType === approvalType;
    });
    var requiredApproval = (_b = state.approvalsData) === null || _b === void 0 ? void 0 : _b.find(function (e) {
        return e.approvalType === requiredApprovalType;
    });
    if (approval) {
        return (0, valueByMode_1.ValueByMode)({
            mode: "view",
            value: "",
        });
    }
    // if (!approval && state.status === 'approved') {
    //     return emptyCell({})
    // console.log({ approvalPermissions });
    // }
    if ((approvalPermissions &&
        requiredApproval &&
        state.status !== "approved" &&
        state.status !== "cancelled" &&
        state.status !== "completed" &&
        state.status !== "draft" &&
        state.status !== "singedAndArchived") ||
        (approvalPermissions &&
            !requiredApprovalType &&
            state.status !== "approved" &&
            state.status !== "cancelled" &&
            state.status !== "completed" &&
            state.status !== "draft" &&
            state.status !== "singedAndArchived")) {
        return {
            action: "Approve",
            payload: {
                approvedAt: state.approvedAtSignatureDate.toDate(),
                approvalType: approvalType,
            },
            text: t("ir.approve"),
            confirmMessage: t("alerts.areYouSureYouWantToApproveThisDocument"),
            confirmAction: true,
            type: "button",
        };
    }
    else {
        return (0, emptyCell_1.emptyCell)({});
    }
};
exports.approvalCell = approvalCell;
function approvals(state, t, mode) {
    // console.log({ state });
    var hasSignature = false;
    var getApproval = function (approvalType) {
        var _a;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        return approval;
    };
    var approvingDate = function (approvalType) {
        var _a;
        var approval2 = getApproval(approvalType);
        var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
        return t("common.date", { date: (_a = (0, moment_1.default)(date)) === null || _a === void 0 ? void 0 : _a.toDate() });
    };
    var approvingSig = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
        return sig;
    };
    var sigMode = function (type) {
        var _a;
        var approval = (_a = state === null || state === void 0 ? void 0 : state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (approval) { return approval.approvalType == type; });
        var newMode = mode == "edit" ? "view" : approval ? "view" : "edit";
        return newMode;
    };
    var user = (0, reduxHooks_1.useAppSelector)(function (store) { return store.auth.currentUser; });
    return [
        [
            // globalUsersData[getApproval("projectManager")?.userId]?.jobTitle !==
            //   "projectManager" &&
            // state.status !== "pendingIrProjectManagerApproval" &&
            // state.status !== "draft" &&
            // state.status !== "cancelled"
            //   ? TitleCell({
            //       title:
            //         globalUsersData[getApproval("projectManager")?.userId]?.jobTitle,
            //     })
            //   : TitleCell({ title: t("ir.projectManager") }),
            (0, titleCell_1.TitleCell)({ title: t("ir.projectManager") }),
            (0, permissiontypes_1.permissionTypes)("showAllSignatures", user.permissions)
                ? (0, exports.approvalCell)(state, "projectManager", t)
                : (0, emptyCell_1.emptyCell)({}),
            // globalUsersData[getApproval("seniorLogisticOfficer")?.userId]
            //   ?.jobTitle !== "seniorLogisticOfficer" &&
            // getApproval("seniorLogisticOfficer") &&
            // state.status !== "pendingIrProjectManagerApproval" &&
            // state.status !== "pendingIrSeniorLogisticOfficerApproval" &&
            // state.status !== "draft" &&
            // state.status !== "cancelled"
            //   ? TitleCell({
            //       title:
            //         globalUsersData[getApproval("seniorLogisticOfficer")?.userId]
            //           ?.jobTitle,
            //     })
            //   : TitleCell({ title: t("ir.seniorLogisticOfficer") }),
            (0, titleCell_1.TitleCell)({ title: t("ir.seniorLogisticOfficer") }),
            !getApproval("seniorLogisticOfficer") &&
                state.status !== "pendingIrSeniorLogisticOfficerApproval"
                ? (0, emptyCell_1.emptyCell)({})
                : (0, permissiontypes_1.permissionTypes)("showAllSignatures", user.permissions)
                    ? (0, exports.approvalCell)(state, "seniorLogisticOfficer", t)
                    : (0, emptyCell_1.emptyCell)({}),
            // globalUsersData[getApproval("financeProjectManager")?.userId]
            //   ?.jobTitle !== "financeProjectManager" &&
            // state.status !== "pendingIrFinanceProjectManagerApproval" &&
            // state.status !== "pendingIrProjectManagerApproval" &&
            // state.status !== "pendingIrSeniorLogisticOfficerApproval" &&
            // state.status !== "draft" &&
            // state.status !== "cancelled"
            //   ? TitleCell({
            //       title:
            //         globalUsersData[getApproval("financeProjectManager")?.userId]
            //           ?.jobTitle,
            //     })
            //   : TitleCell({ title: t("ir.financeProjectManager") }),
            (0, titleCell_1.TitleCell)({ title: t("ir.financeProjectManager") }),
            (0, permissiontypes_1.permissionTypes)("showAllSignatures", user.permissions)
                ? (0, exports.approvalCell)(state, "financeProjectManager", t, "projectManager")
                : (0, emptyCell_1.emptyCell)({}),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.deputyGeneral") }),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, permissiontypes_1.permissionTypes)("showAllSignatures", user.permissions)
                    ? (0, exports.approvalCell)(state, "deputyGeneral", t, "financeProjectManager")
                    : (0, emptyCell_1.emptyCell)({}),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.generalDirector") }),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, permissiontypes_1.permissionTypes)("showAllSignatures", user.permissions)
                    ? (0, exports.approvalCell)(state, "generalDirector", t, "deputyGeneral")
                    : (0, emptyCell_1.emptyCell)({}),
        ],
        // TODO: working///
        [
            (0, titleCell_1.TitleCell)({ title: t("ir.dateApproved") }),
            (0, valueByMode_1.ValueByMode)({
                mode: sigMode("projectManager"),
                value: sigMode("projectManager") === "view"
                    ? approvingDate("projectManager")
                    : state.approvedAtSignatureDate,
                inputType: "datePicker",
                path: "approvedAtSignatureDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.dateApproved") }),
            // ValueCell({
            //   value:
            //     approvingDate("seniorLogisticOfficer") &&
            //     approvingDate("financeProjectManager"),
            //   colSpan: 1,
            // }), // fake appearance of logistics date for temporary to find another way
            !getApproval("seniorLogisticOfficer") &&
                state.status !== "pendingIrSeniorLogisticOfficerApproval"
                ? (0, emptyCell_1.emptyCell)({})
                : (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("seniorLogisticOfficer"),
                    value: sigMode("seniorLogisticOfficer") === "view"
                        ? approvingDate("seniorLogisticOfficer")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
            (0, titleCell_1.TitleCell)({ title: t("ir.dateApproved") }),
            // ValueCell({ value: approvingDate("financeProjectManager"), colSpan: 1 }),
            getApproval("projectManager")
                ? (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("financeProjectManager"),
                    value: sigMode("financeProjectManager") === "view"
                        ? approvingDate("financeProjectManager")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                })
                : (0, emptyCell_1.emptyCell)({}),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.dateApproved") }),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : !getApproval("financeProjectManager") ||
                    (!getApproval("deputyGeneral") && state.status === "approved") ||
                    (!getApproval("deputyGeneral") &&
                        state.status === "pendingIrSeniorLogisticOfficerApproval")
                    ? (0, emptyCell_1.emptyCell)({})
                    : // : ValueCell({ value: approvingDate("deputyGeneral"), colSpan: 1 }),
                        (0, valueByMode_1.ValueByMode)({
                            mode: sigMode("deputyGeneral"),
                            value: sigMode("deputyGeneral") === "view"
                                ? approvingDate("deputyGeneral")
                                : state.approvedAtSignatureDate,
                            inputType: "datePicker",
                            path: "approvedAtSignatureDate",
                            required: state.triedSubmitting,
                            triedSubmitting: state.triedSubmitting,
                        }),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.dateApproved") }),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : !getApproval("deputyGeneral") ||
                    (!getApproval("generalDirector") && state.status === "approved") ||
                    (!getApproval("generalDirector") &&
                        state.status === "pendingIrSeniorLogisticOfficerApproval")
                    ? (0, emptyCell_1.emptyCell)({})
                    : // : ValueCell({ value: approvingDate("generalDirector"), colSpan: 1 }),
                        (0, valueByMode_1.ValueByMode)({
                            mode: sigMode("generalDirector"),
                            value: sigMode("generalDirector") === "view"
                                ? approvingDate("generalDirector")
                                : state.approvedAtSignatureDate,
                            inputType: "datePicker",
                            path: "approvedAtSignatureDate",
                            required: state.triedSubmitting,
                            triedSubmitting: state.triedSubmitting,
                        }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
            (0, valueCell_1.ValueCell)({
                value: " ",
                img: hasSignature && approvingSig("projectManager"),
                colSpan: 1,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
            (0, valueCell_1.ValueCell)({
                value: " ",
                img: hasSignature && approvingSig("seniorLogisticOfficer"),
                colSpan: 1,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
            (0, valueCell_1.ValueCell)({
                value: " ",
                img: hasSignature && approvingSig("financeProjectManager"),
                colSpan: 1,
            }),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
            (!getApproval("deputyGeneral") && state.status === "approved") ||
                (!getApproval("deputyGeneral") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("deputyGeneral"),
                    colSpan: 1,
                }),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, titleCell_1.TitleCell)({ title: t("ir.signature") }),
            (!getApproval("generalDirector") && state.status === "approved") ||
                (!getApproval("generalDirector") &&
                    state.status === "pendingIrSeniorLogisticOfficerApproval")
                ? null
                : (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("generalDirector"),
                    colSpan: 1,
                }),
        ],
    ];
}
exports.approvals = approvals;
function logoHeader(_a) {
    var projectId = _a.projectId, idaLogo = _a.idaLogo, title = _a.title, colSpan = _a.colSpan, addEmptyCell = _a.addEmptyCell;
    return __spreadArray([
        (0, header_1.IdaLogo)({ colSpan: 4, projectId: projectId }),
        (0, header_1.formTitle)({ title: title, colSpan: colSpan !== null && colSpan !== void 0 ? colSpan : 2 }),
        idaLogo
    ], (addEmptyCell ? [(0, emptyCell_1.emptyCell)({ rowSpan: 4 })] : []), true);
}
exports.logoHeader = logoHeader;
function irHeader(state, mode, officesOptions, projectsOptions, budgetLineOption, t) {
    var _a, _b, _c;
    var office = officesList_1.globalOfficesData[state.officeId];
    var prCode = (_a = projectsList_1.globalProjectsData[state.projectId]) === null || _a === void 0 ? void 0 : _a.code;
    return [
        [
            (0, titleCell_1.TitleCell)({ title: t("ir.date") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", { date: (0, getDateForCell_1.default)(state.IRDate, mode) })
                    : (0, getDateForCell_1.default)(state.IRDate, mode),
                inputType: "datePicker",
                path: "IRDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.office") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: office === null || office === void 0 ? void 0 : office.name,
                inputType: "select",
                selectData: officesOptions,
                path: "officeId",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.irNo"), colSpan: 1 }),
            // ValueByMode({
            //   mode:
            //     state.status === "pendingIrSeniorLogisticOfficerApproval"
            //       ? "edit"
            //       : "view",
            //   value: state.ref,
            //   colSpan: 1,
            //   inputType: "textInput",
            //   path: "ref",
            //   required:
            //     state.status === "pendingIrSeniorLogisticOfficerApproval"
            //       ? state.triedSubmitting
            //       : null,
            //   triedSubmitting:
            //     state.status === "pendingIrSeniorLogisticOfficerApproval"
            //       ? state.triedSubmitting
            //       : null,
            // }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.ref,
                colSpan: 1,
                inputType: "textInput",
                path: "ref",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.projectCode"), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.projectsIds,
                viewValue: state.projectsIds
                    .map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId]) === null || _a === void 0 ? void 0 : _a.code; })
                    .join(", "),
                colSpan: 2,
                inputType: "select",
                selectMode: "multiple",
                path: "projectsIds",
                selectData: projectsOptions,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("ir.department"), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.department,
                colSpan: 3,
                inputType: "textArea",
                path: "department",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.projectStartDate"), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: state.projectsIds
                    .map(function (projectId) {
                    var _a;
                    return t("common.date", {
                        date: (0, getDateForCell_1.default)((_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : " "]) === null || _a === void 0 ? void 0 : _a.startingDate, "view"),
                    });
                })
                    .join(" | "),
                // viewValue: globalWarehousesData[state.deliveryLocation]?.name,
                colSpan: 2,
                inputType: "select",
                path: "projectStartDate",
                selectData: (0, map_1.default)(warehousesList_1.globalWarehousesData, function (v) { return ({
                    text: v.name,
                    value: v.id,
                }); }),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.projectEndDate") }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: state.projectsIds
                    .map(function (projectId) {
                    var _a;
                    return t("common.date", {
                        date: (0, getDateForCell_1.default)((_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : " "]) === null || _a === void 0 ? void 0 : _a.endingDate, "view"),
                    });
                })
                    .join(" | "),
                colSpan: 2,
                inputType: "numberInput",
                path: "projectEndDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            // TitleCell({ title: t('ir.budgetLine') }),
            // ValueByMode({
            //     mode,
            //     value: globalBudgetLinesData[state.budgetLineId]?.code,
            //     viewValue: globalBudgetLinesData[state.budgetLineId]?.code,
            //     colSpan: 1,
            //     inputType: 'select',
            //     path: 'budgetLineId',
            //     selectData: budgetLineOption,
            //     required: state.triedSubmitting,
            //     triedSubmitting: state.triedSubmitting,
            // }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("ir.descriptionOfFullIr"), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.description,
                colSpan: 3,
                inputType: "textArea",
                path: "description",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.deliveryLocation"), colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.deliveryLocation,
                viewValue: (_b = warehousesList_1.globalWarehousesData[state.deliveryLocation]) === null || _b === void 0 ? void 0 : _b.name,
                colSpan: 2,
                inputType: "select",
                path: "deliveryLocation",
                selectData: (0, map_1.default)(warehousesList_1.globalWarehousesData, function (v) { return ({
                    text: v.name,
                    value: v.id,
                }); }),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("ir.exchangeRate1Usd") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_c = state === null || state === void 0 ? void 0 : state.exchangeRate) !== null && _c !== void 0 ? _c : "",
                colSpan: 2,
                inputType: "numberInput",
                path: "exchangeRate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            // TitleCell({ title: t('ir.budgetLine') }),
            // ValueByMode({
            //     mode,
            //     value: globalBudgetLinesData[state.budgetLineId]?.code,
            //     viewValue: globalBudgetLinesData[state.budgetLineId]?.code,
            //     colSpan: 1,
            //     inputType: 'select',
            //     path: 'budgetLineId',
            //     selectData: budgetLineOption,
            //     required: state.triedSubmitting,
            //     triedSubmitting: state.triedSubmitting,
            // }),
        ],
    ];
}
exports.irHeader = irHeader;
